/**
 * [CUSTOM:L0] 品牌 —— 登录页的应用名、字标、说明的唯一定义处（LeapWorldTwin-1000，定制点分级见 `docs/architecture/10-customization.md`）。
 * 改品牌只改本文件；页面只消费它，不把应用名写死在页面里。
 */

export const branding = {
  /** 完整应用名：登录页标题。 */
  name: "跃迁积分",
  /** 一句业务说明：登录页左栏（会被放大展示，写业务说法）。 */
  description: "申报贡献，评议审批后入账，积分可兑换或扣分。",
  /** 登录页字标：1–2 个字。 */
  glyph: "积",
  /** 登录页左栏「这里能做什么」，最多 3 条，可不填。 */
  loginHighlights: ["提交积分申报", "评议和审批，积分入账", "兑换奖励，台账可追溯"],
} as const;
